export default __webpack_public_path__ + "static/media/svg-1.25646a96.svg";